import script from "./UpdateAutomationSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateAutomationSidebar.vue?vue&type=script&setup=true&lang=js"

import "./UpdateAutomationSidebar.vue?vue&type=style&index=0&id=c82588b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c82588b0"]])

export default __exports__